import React from "react"
import {
  MapContainer,
  Marker,
  TileLayer,
  ZoomControl,
} from "react-leaflet"
import L from "leaflet"

import classes from "./OhAddressOnMap.module.scss"
import "leaflet/dist/leaflet.css"

delete L.Icon.Default.prototype._getIconUrl

const customIcon =
  new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  })

const OhAddressOnMap = props => {
  const { lat, lng } = props

  return (
    <div className={classes["container"]}>
      <MapContainer
        zoom={5}
        center={{ lat: lng, lng: lat }}
        className={classes["map"]}
        attributionControl={false}
        zoomControl={false}
      >
        <ZoomControl position="bottomright" />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
        />
        <Marker
          icon={customIcon}
          position={{ lat: lng, lng: lat }}
        />
      </MapContainer>
    </div>
  )
}

export default OhAddressOnMap